<template>
    <div v-loading="loading">
        <EditorTitle
            :showReturnBtn="true"
            :returnLabel="i18n.tkey('lang_return')"
            :titleLabel="i18n.tkey('lang_delivery_remark')"
            :showOperationBtn="true"
            :operationLabel="i18n.tkey('lang_add_delivery_deliveryname')"
            :operationType="'warning'"
            @clickReturnBtn="clickReturnBtn"
            @clickOperationBtn="changeViewPart('edit')"
            tkey="運輸備註"
        />

        <div v-show="viewPart == 'list'">
            <deliverynameList :list="recordList" v-if="recordList.length > 0" @clickEditBtn="goEditPart" @clickDelBtn="saveCallback" />
            <el-empty v-if="recordList.length == 0" :description="i18n.tkey('lang_temporary_no_data')" v-show="recordList.length == 0" />
        </div>

        <div v-if="viewPart == 'edit'">
            <insertOrEditDeliveryname :editObj="editObj" :disabledCountryList="disabledCountryList" @save-success="saveCallback" />
        </div>

    </div>
</template>

<script setup>
    import deliverynameList from "@/components/shopopee/deliveryname/deliverynameList"
    import insertOrEditDeliveryname from "@/components/shopopee/deliveryname/insertOrEditDeliveryname"
    import ReturnButton from "@/components/shopopee/common/returnButton.vue";
    import {inject, ref, onBeforeMount} from "vue";
    import eshopopeeApi from "@/request/eshopopeeApi";
    import EditorTitle from "@/components/shopopee/common/editorTitle.vue";

    const props = defineProps(["showReturnBtn"])
    const emits = defineEmits(["clickReturnBtn"])

    const i18n = inject("i18n")
    const loading = ref(false)

    const viewPart = ref("list")
    const recordList = ref([])
    const editObj = ref(null)
    const disabledCountryList = ref([])

    const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })

    const shopCompany = ref({})

    function getRecordList(){
        loading.value = true

        const request = eshopopeeApi.getDeliverynameRecordList
        const params = request.getParams()

        params.CompanyCode = shopCompany.value.acccompanycode

        request.send(params, (res) => {
            loading.value = false
            if (res.code == 200){
                recordList.value = res.list
                getDisabledCountryList()
            }
        })

    }

    function getDisabledCountryList(){
        const list = new Set()

        recordList.value.forEach((v, i) => {
            list.add(v.District1)
        })

        disabledCountryList.value = [...list]
    }

    function changeViewPart(name){
        if (name != "edit"){
            editObj.value = null
        }

        viewPart.value = name
    }

    function saveCallback(){
        changeViewPart("list")
        getRecordList()
    }

    function goEditPart(obj){
        editObj.value = obj
        changeViewPart("edit")
    }

    function clickReturnBtn(){
        if (viewPart.value === "list"){
            emits("clickReturnBtn")
        }else{
            changeViewPart("list")
        }
    }

    onBeforeMount(() => {
        shopCompany.value = getShopCompanyObj()

        getRecordList()
    })

</script>

<style scoped>
    .title-operation {
        //display: flex;
        //align-items: center;
        //justify-content: space-between;
        margin-bottom: 30px;
        position: relative;
    }
</style>